export const ALL_PERMISSIONS_REQUEST = "ALL_PERMISSIONS_REQUEST";
export const ALL_PERMISSIONS_SUCCESS = "ALL_PERMISSIONS_SUCCESS";
export const ALL_PERMISSIONS_FAIL = "ALL_PERMISSIONS_FAIL";


export const PUT_PERMISSION_REQUEST = "PUT_PERMISSION_REQUEST";
export const PUT_PERMISSION_SUCCESS = "PUT_PERMISSION_SUCCESS";
export const PUT_PERMISSION_FAIL = "PUT_PERMISSION_FAIL";